
$(document).on('change', `.js-eq-quiz-product-page-form [data-option-1], .js-eq-quiz-product-page-form [data-option-2],.js-eq-quiz-product-page-form [data-option-3]`, function (e) {
    let option1 = option2 = option3 = null;
   
    let parent = $(this).closest('.card-information');
    
    if (parent.find(`.js-eq-quiz-product-page-form [data-option-1]`).length > 0) {
       option1 = parent.find(`.js-eq-quiz-product-page-form [data-option-1] input:checked`).val();
    } 
    if (parent.find(`.js-eq-quiz-product-page-form [data-option-2]`).length > 0) {
       option2 = parent.find(`.js-eq-quiz-product-page-form [data-option-2] input:checked`).val();
    }
    if (parent.find(`.js-eq-quiz-product-page-form [data-option-3]`).length > 0) {
       option3 = parent.find(`.js-eq-quiz-product-page-form [data-option-3] input:checked`).val();
    }
    let variant_id = null;
    let current_selected_option = null;
    if (option2 == null & option3 == null) {

       current_selected_option = parent.find(`.js-eq-quiz-product-page-form select.actual-variants option[data-option1='${option1}']`);
       variant_id = parent.find(`.js-eq-quiz-product-page-form select.actual-variants option[data-option1='${option1}']`).val();
    }
    if (option2 != null & option3 == null) {

       current_selected_option = parent.find(`.js-eq-quiz-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`);
       variant_id = parent.find(`.js-eq-quiz-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`).val();
    }
    if (option2 != null & option3 != null) {

       current_selected_option = parent.find(`.js-eq-quiz-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`);
       variant_id = parent.find(`.js-eq-quiz-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`).val();
    }
   
    if (variant_id == null) {
       $(`.js-eq-quiz-product-page-form .stock`).fadeOut(100);
       $(`.js-eq-quiz-product-page-form .js-out-stock`).fadeIn(100);
       $(`.js-eq-quiz-product-page-form .product_page_atc`).addClass('soldout');
       $(`.js-eq-quiz-product-page-form .product_page_atc span`).text("Unavailable");
       return true;
    }
    let price = $(current_selected_option).attr('data-price');
    let is_available = $(current_selected_option).attr('data-available');
     let subscriptionPercentage = $(current_selected_option).attr('data-sub-per');
     let variantPrice = $(current_selected_option).attr('data-money_without-currency-price');
    let discountPrice = parseFloat((variantPrice * subscriptionPercentage) / 100);
    let subscriptionPrice = parseFloat(variantPrice - discountPrice);
    let bestByDate = $(current_selected_option).attr('data-best-by-date');
    parent.find('.eq-product-best-by p').html(bestByDate);
    parent.find('.subscription-price').html(Shopify.formatMoney(subscriptionPrice, $('body').data('money-format')));
    parent.find(`.js-eq-quiz-product-page-form select.actual-variants`).val(variant_id).trigger('change'); 
    // $(`.js-eq-quiz-product-page-form .js-compare-price`).text(compare_at_price);
    parent.find(`.product-one-time-price`).text(price);
    if (is_available == 'true') {
        parent.find(`.eq-quiz-atc `).html(`<img src="//joyorganics.com/cdn/shop/files/eq-product-btn-cart-icon_250x.png?v=9807713154866607732" alt="cart icon"> <span>Add to cart</span>`);
        parent.find(`.eq-quiz-atc`).css("pointer-events", "all");
        parent.find(`.eq-quiz-atc`).css("opacity", "1");
    } else {
        parent.find(`.eq-quiz-atc`).css("pointer-events", "none");
        parent.find(`.eq-quiz-atc`).css("opacity", "0.5");
        parent.find(`.eq-quiz-atc`).html("Soldout");
        parent.find(`.eq-quiz-atc`).css("color", "#fff");
    }
 });

 $(document).on('click', '.one-time-atc', function (e) {
    e.preventDefault();
    let parent = $(this).closest('.card-information');
    let variantId = parent.find('.js_product_var_change option:selected').val();
    let customStrength = parent.find('.custom-meta-strength:checked').val();
    let qty = 1;
    let data = {};
    data = { 
        id: variantId,
        quantity: qty,
        properties: {
            'Strength': customStrength
        }
     }; 
    $.ajax({
       url: "/cart/add.js",
       method: "POST",
       data: data,
       dataType: "json",
       success: function (data) {
          // window.location = "/cart";
       },
       error: function (xhr, status, error) {
          console.error("Error adding to cart:", error);
          console.error("Response Text:", xhr.responseText);
          window.alert(xhr.responseJSON.description);
       }
    });
 });

  $(document).on('change', '.collection-sellingplan-dropdown', function (e) {
    e.preventDefault();
    let parent = $(this).closest('.card-information');
    let variantId = parent.find('.js_product_var_change option:selected').val();
    let sellingPlanId = parent.find('.collection-sellingplan-dropdown option:selected').val();
    let customStrength = parent.find('.custom-meta-strength:checked').val();
    let qty = 1;
    let data = {};
    data = {
        id: variantId,
        quantity: qty,
        selling_plan: sellingPlanId,
        properties: {
            'Strength': customStrength
        }
       
     }; 
    $.ajax({
       url: "/cart/add.js",
       method: "POST",
       data: data,
       dataType: "json",
       success: function (data) {
         document.querySelectorAll(".js-eq-product-price-dropdown").forEach(el => {
            el.classList.remove("show");
         });
         document.getElementById("sellingplan-dropdown").selectedIndex = 0;
          // window.location = "/cart";
       },
       error: function (xhr, status, error) {
          console.error("Error adding to cart:", error);
          console.error("Response Text:", xhr.responseText);
          window.alert(xhr.responseJSON.description);
       }
    });
 });

 $( document ).ready(function() {
   $('input[type="radio"]:checked').trigger('change');
});